import { cloneElement } from 'react';
import { NavLink, useLocation, useParams } from 'react-router-dom';
import { Box, NavItem } from '@optiaxiom/react';

import CanInstance from '@frontend/components/CanInstance';
import CanUser from '@frontend/components/CanUser';
import { FeatureFlag } from '@frontend/contexts';
import { InstanceOperationsName, OperationsName } from '@frontend/types';

import * as styles from './NavigationItem.css';

type NavigationItemProps = {
  path: string;
  icon: JSX.Element;
  label: string;
  permissions: OperationsName[];
  instanceCapabilities?: InstanceOperationsName[];
  featureFlag?: string;
  showIndicator?: boolean;
};

/* TODO: Add doc string */
export const NavigationItem = ({
  path,
  icon,
  label,
  permissions,
  instanceCapabilities = [],
  featureFlag,
  showIndicator = false,
}: NavigationItemProps) => {
  const location = useLocation();
  const { instanceId } = useParams();
  const selectedRoute = location.pathname.split('/')[3] || 'chat';

  const [pathBase, pathQuery] = path.split('?');
  const isActive = pathQuery
    ? selectedRoute === pathBase && location.search === `?${pathQuery}`
    : selectedRoute === path;

  const iconWithBadge = showIndicator ? (
    <Box className={styles.iconWithIndicator}>
      {cloneElement(icon, { filled: selectedRoute === path })}
      <Box className={styles.unreadIndicator} />
    </Box>
  ) : (
    cloneElement(icon, { filled: selectedRoute === path })
  );

  const navItem = (
    <NavLink
      to={`/instances/${instanceId}/${path}`}
      style={{ textDecoration: 'none', color: 'inherit' }}
    >
      <Box className={styles.navItemContainer}>
        <NavItem active={isActive} icon={iconWithBadge}>
          {label}
        </NavItem>
      </Box>
    </NavLink>
  );

  const withPermission = <CanUser operations={permissions}>{navItem}</CanUser>;

  const withCapabilities =
    instanceCapabilities.length > 0 ? (
      <CanInstance capabilities={instanceCapabilities}>{withPermission}</CanInstance>
    ) : (
      withPermission
    );

  if (featureFlag) {
    return <FeatureFlag featureKey={featureFlag}>{withCapabilities}</FeatureFlag>;
  }

  return withCapabilities;
};
